(()=>{
  function initialize(){
    const nav=document.querySelector('#bc-navigation');
    if(nav&&!nav.dataset.sequenceReady){
      nav.dataset.sequenceReady='true';
      const groups=[...nav.querySelectorAll('.bc-nav-group')];
      groups.forEach(group=>group.addEventListener('toggle',()=>{if(group.open)groups.forEach(other=>{if(other!==group)other.open=false;});}));
      document.addEventListener('click',event=>{if(!nav.contains(event.target))groups.forEach(g=>g.open=false);});
      document.addEventListener('keydown',event=>{if(event.key==='Escape'){groups.forEach(g=>g.open=false);nav.dataset.open='false';document.querySelector('.bc-menu')?.setAttribute('aria-expanded','false');}});
    }
  }
  initialize();document.addEventListener('shopify:section:load',initialize);
})();
